<app-tabs-main [selectedIndex]="selectedIndex" [disabled]="!crewInfo?.hasAccess">
    <app-new-reservation newReservation></app-new-reservation>
</app-tabs-main>
